import { mm } from "@inovitas/infra3dsdk";

export interface FeatureTableAddedRows {
  length: number;
  inserted: mm.Feature[];
  updated: mm.Feature[];
  deleted: mm.Feature[];
}

const getChangedFeaturesList = (layer: mm.Layer) => {
  const insertedList = layer.getLayerEditor().featuresinsert.features;
  const updatedListID = Object.keys(layer.getLayerEditor().featuresupdate);
  const deletedListID = layer.getLayerEditor().featuresdelete;
  const updatedList: mm.Feature[] = [];
  const deletedList: mm.Feature[] = [];
  updatedListID.forEach((id) => {
    updatedList.push(layer.getFeatureById(id));
  });
  deletedListID.forEach((id: string) => {
    deletedList.push(layer.getFeatureById(id));
  });

  const rows: FeatureTableAddedRows = {
    length: insertedList.length + updatedList.length + deletedList.length,
    inserted: insertedList,
    updated: updatedList,
    deleted: deletedList,
  };

  return rows;
};
export default getChangedFeaturesList;
